<form class="form-horizontal p-2" [formGroup]="blacklistForm">
  <div class="form-row row">
    <div class="col-12 col-lg-6">
      <div class="form-group row">
        <label class="col-5 control-label">
          {{'i18n.domain.administration.zone-details.zone-details-form.fields.useBlacklistArea' | translate}}
        </label>
        <div class="col-7">
          <app-yes-no-group-button id="useBlacklistArea" formControlName="useBlacklistArea"></app-yes-no-group-button>
        </div>
      </div>
    </div>
  </div>
  @if (blacklistForm.controls.useBlacklistArea.value) {
    <div class="form-row row">
      <div class="row spacer">
        <div class="col-12">
          <app-map-box-map [(mapData)]="mapData" mapId="blacklistMap" [isSingleMode]="false"></app-map-box-map>
        </div>
      </div>
    </div>
  }
  <input type="hidden" id="blacklistGPSArea" formControlName="blacklistGPSArea">
</form>
